import { render, staticRenderFns } from "./TsDragScroll.vue?vue&type=template&id=6e5c7818&scoped=true&"
import script from "./TsDragScroll.vue?vue&type=script&lang=js&"
export * from "./TsDragScroll.vue?vue&type=script&lang=js&"
import style0 from "./TsDragScroll.vue?vue&type=style&index=0&id=6e5c7818&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5c7818",
  null
  
)

export default component.exports